import { useMemo } from "react";

import { CustomerModalKeys } from "components/CustomerModal/queryKeys";
import { typedQueryClient } from "hooks";

import type { WebSocketMessageListener } from "components/WebSocket";
import type { Customer } from "models";

export const useCustomerListeners = (id: number): WebSocketMessageListener<Customer>[] =>
  useMemo(
    () => [
      {
        model: "Customer",
        action: "upsert",
        id,
        callback: ({ data: updatedCustomer }) => {
          const customer = typedQueryClient.getQueryData(CustomerModalKeys.customerWithServiceDetails);
          if (!customer) return;

          typedQueryClient.setQueryData(CustomerModalKeys.customerWithServiceDetails, { ...customer, ...updatedCustomer });
        }
      }
    ],
    [id]
  );
